import script from "./Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=70ca01db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ca01db"]])

export default __exports__